// src/utils/slug.js

function createSlug(text) {
    // Türkçe karakterleri İngilizce karşılıklarıyla değiştir
    const turkishToEnglish = {
      'ğ': 'g',
      'ü': 'u',
      'ş': 's',
      'ı': 'i',
      'ö': 'o',
      'ç': 'c',
      'Ğ': 'G',
      'Ü': 'U',
      'Ş': 'S',
      'İ': 'I',
      'Ö': 'O',
      'Ç': 'C',
    };
  
    return text
      .toString() // Gelen verinin string olduğundan emin ol
      .toLowerCase() // Tüm harfleri küçük yap
      .trim() // Baştaki ve sondaki boşlukları kaldır
      .replace(/[ğüşıöçĞÜŞİÖÇ]/g, (match) => turkishToEnglish[match]) // Türkçe karakterleri dönüştür
      .replace(/\s+/g, '-') // Boşlukları tire ile değiştir
      .replace(/[^\w\-]+/g, '') // Alfanümerik olmayan karakterleri kaldır
      .replace(/\-\-+/g, '-') // Birden fazla tireyi tek tireye indir
      .replace(/^-+|-+$/g, ''); // Baştaki ve sondaki tireleri kaldır
  }

export default createSlug;
